import React, { useContext, useEffect, useState } from 'react';
import baseUrl from "../../../../BaseURL";
import { ContextData } from '../../../../context/Context';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button } from '@mui/material';
import { generateMembershipPrefix } from '../IDCard/membershipNumber';
import MemberIdentityCard from '../IDCard/MemberIdentityCard';
import '../IDCard/CardStudio.css';

export default function PreCardShow({ profileData, Slot }) {

  const {
    Refresh, setRefresh,
    accesstoken, issuance, setissuance,
     setfirstSlot,
     setsecondSlot,
     firstSlot,secondSlot,
  } = useContext(ContextData);
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [matchedCodes, setMatchedCodes] = useState([]);
  const [ ID_ref_Num, setID_ref_Num] = useState("")
  const [localValue,setlocalValue] = useState("")

  const {
    fname, lname, gender, age, position, department,
    stateoforigin, picture, r_ID, id_ref_num,lga,id_card_status,member_address
  } = profileData;

  const [editField, setEditField] = useState(null);
  const [post, setPost] = useState(position || "");
  const [dep, setDep] = useState(department || "");
  const [formData, setFormData] = useState({
    fname: fname || "",
    lname: lname || "",
    gender: gender || "",
    stateoforigin: stateoforigin || "",
    lga: lga || ""
  });

  useEffect(() => {
    setFormData({
      fname: profileData.fname || "",
      lname: profileData.lname || "",
      gender: profileData.gender || "",
      stateoforigin: profileData.stateoforigin || "",
      lga: profileData.lga || ""
    });
    setPost(profileData.position || "");
    setDep(profileData.department || "");
  }, [profileData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "position") setPost(value);
    else if (name === "department") setDep(value);
    else setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleIDNumChange = (e) => setMatchedCodes(e.target.value);

  const handleIssuanceChange = (e) => {
    setissuance(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleUpdate = async (type) => {
    let data = { r_ID, type };
    switch (type) {
      case "dept": data.value = dep; break;
      case "post": data.value = post; break;
      case "idRefnum": data.value = matchedCodes; break;
      case "fname": data.value = formData.fname; break;
      case "lname": data.value = formData.lname; break;
      case "gender": data.value = formData.gender; break;
      case "lga": data.value = formData.lga; break;
      case "stateoforigin": data.value = formData.stateoforigin; break;
      default: return;
    }
    try {
      const res = await axios.put(`${baseUrl}/auth/update_card_inputs`, data, {
        withCredentials: true,
        headers: {
          'Accept': 'application/json',
          'authorization': `Bearer ${accesstoken || ""}`
        }
      });
      toast.success(res.data.statusText);
      setEditField(null);
      setRefresh(r => !r);
    } catch (err) {
      toast.warn(err.message);
    }
  };

  const handleDone = async () => {

    if (!matchedCodes) {
      toast.warn("Reference number is empty, please fill it and click update.");
      return;
    }
    try {
      const res = await axios.put(`${baseUrl}/auth/approve_id_card/${r_ID}`, {}, {
        withCredentials: true,
        headers: {
          'Accept': 'application/json',
          'authorization': `Bearer ${accesstoken || ""}`
        }
      });


      toast.success(res.data.statusText);
      setRefresh(r => !r);
    } catch {
      toast.warn("Error updating ID card status");
    }
  };


  const handlocalvalue = (e)=>{

          const value = e.target.value;
          setlocalValue(value);


  }





  useEffect(() => {
    setMatchedCodes(generateMembershipPrefix(profileData));

  }, [profileData]);











  return (
    <div className="fin-card-studio fin-batch-studio hide-at-prnt">
      <section className="fin-card-preview" aria-label={`${Slot} card preview`}>
        <div className="fin-card-section-heading"><div><p className="fin-studio-eyebrow">{Slot}</p><h3>Membership identity</h3></div><span className="fin-card-tag">{id_card_status === 'finished' ? 'Finished' : 'In preparation'}</span></div>
        <MemberIdentityCard data={{ ...profileData, ...formData, position: post, department: dep }} stateOfIssue={issuance.state} dateOfIssu={issuance.issuDate} dateOfExpiry={issuance.expiry} ID_ref_Num={`${matchedCodes || id_ref_num || ''}/${r_ID || ''}`} />
        <p className="fin-card-preview-note">Live preview · Save edits below before opening the print sheet, which uses saved member details.</p>
      </section>
      <section className="fin-card-editor" aria-label={`${Slot} card details`}>
        <div className="fin-card-section-heading"><div><p className="fin-studio-eyebrow">REVIEW MEMBER DETAILS</p><h3>Prepare for printing</h3></div>
          {id_card_status === '0' && <Button onClick={handleDone} variant="contained">Mark done</Button>}
          {id_card_status === 'finished' && <Button disabled variant="contained">Done</Button>}
        </div>
        <fieldset className="fin-card-fieldset fin-card-member-fields"><legend>Member information</legend>
          <div className="fin-card-edit-row"><div><span>Full name</span><strong>{fname} {lname}</strong></div>{editField !== 'fullname' && <Button onClick={() => setEditField('fullname')}>Edit</Button>}</div>
          {editField === 'fullname' && <div className="fin-card-name-fields">{[['fname', 'First name'], ['lname', 'Last name']].map(([key,label]) => <div className="fin-card-field" key={key}><label htmlFor={`${key}-${r_ID}`}>{label}</label><div><input id={`${key}-${r_ID}`} name={key} value={formData[key]} onChange={handleInputChange} /><Button onClick={() => handleUpdate(key)} variant="outlined">Save</Button></div></div>)}</div>}
          {[
            ['gender', 'Gender', gender, 'gender', formData.gender],
            ['post', 'Position', position, 'position', post],
            ['dept', 'Department', department, 'department', dep],
            ['stateoforigin', 'State of origin', stateoforigin, 'stateoforigin', formData.stateoforigin],
            ['lga', 'Local government', lga, 'lga', formData.lga]
          ].map(([key,label,saved,name,value]) => <div className="fin-card-edit-row" key={key}>{editField === key ? <div className="fin-card-field"><label htmlFor={`${name}-${r_ID}`}>{label}</label><div><input id={`${name}-${r_ID}`} name={name} value={value} onChange={handleInputChange} /><Button onClick={() => handleUpdate(key)} variant="outlined">Save</Button></div></div> : <><div><span>{label}</span><strong>{saved || '—'}</strong></div><Button onClick={() => setEditField(key)}>Edit</Button></>}</div>)}
          <div className="fin-card-edit-row"><div><span>Age</span><strong>{age || '—'}</strong></div></div>
        </fieldset>
        <fieldset className="fin-card-fieldset"><legend>Membership number</legend><p className="fin-card-help">Review the reference prefix and save it before completing the card.</p>
          <div className="fin-card-field"><label htmlFor={`reference-${r_ID}`}>Reference prefix</label><div><input id={`reference-${r_ID}`} value={matchedCodes} onChange={handleIDNumChange} /><Button onClick={() => handleUpdate('idRefnum')} variant="outlined">Save</Button></div></div>
          <p className="fin-card-number-preview">Saved: FIN/{id_ref_num || '—'}/{r_ID}</p>
        </fieldset>
        <fieldset className="fin-card-fieldset"><legend>Issuance details</legend><div className="fin-card-issuance-grid">
          {[['state','State of issue'],['issuDate','Date of issue'],['expiry','Expiry date']].map(([key,label]) => <div className="fin-card-field" key={key}><label htmlFor={`${key}-${r_ID}`}>{label}</label><input id={`${key}-${r_ID}`} name={key} value={issuance[key]} onChange={handleIssuanceChange} /></div>)}
        </div></fieldset>
        <details className="fin-card-advanced"><summary>Reference prefix shortcut</summary><p className="fin-card-help">Reuse a prefix while this card is open.</p><div className="fin-card-field"><label htmlFor={`shortcut-${r_ID}`}>Reusable prefix</label><div><input id={`shortcut-${r_ID}`} value={localValue} onChange={handlocalvalue} name="localValue" /><Button onClick={() => setMatchedCodes(localValue)} variant="outlined">Use prefix</Button></div></div><p className="fin-card-help">Current prefix: {localValue || 'None'}</p></details>
        <div className="fin-card-readonly"><span>Member address</span><p>{member_address || 'Not provided'}</p></div>
      </section>
    </div>
  );
}
